const readMoreProduct = document.querySelector('.js-product__read-more');
const readLessProduct = document.querySelector('.js-product__read-less');
const productDescription = document.querySelector('.js-product__description');

if (readMoreProduct && readLessProduct && productDescription) {
  productDescription.classList.remove('product__description--show');
  readLessProduct.classList.add('product__read-less--hide');
  readMoreProduct.hidden = true;

  requestAnimationFrame(() => {
    const truncated = productDescription.scrollHeight > productDescription.clientHeight + 1;
    if (truncated) {
      readMoreProduct.classList.remove('product__read-more--hide');
      readMoreProduct.hidden = false;
    } else {
      productDescription.classList.add('product__description--show');
      readMoreProduct.classList.add('product__read-more--hide');
      readMoreProduct.hidden = true;
    }
  });

  readMoreProduct.addEventListener('click', () => {
    productDescription.classList.add('product__description--show');
    readMoreProduct.classList.add('product__read-more--hide');
    readMoreProduct.hidden = true;
    readLessProduct.classList.remove('product__read-less--hide');
  });

  readLessProduct.addEventListener('click', () => {
    productDescription.classList.remove('product__description--show');
    readLessProduct.classList.add('product__read-less--hide');
    readMoreProduct.classList.remove('product__read-more--hide');
    readMoreProduct.hidden = false;
  });
}

const mainProductSection = document.querySelector('section[id^="MainProduct-"]');
const mainButtonsRow =
  mainProductSection instanceof HTMLElement
    ? mainProductSection.querySelector('.main-product__row-buttons')
    : null;
const stickyButtonsRow =
  mainProductSection instanceof HTMLElement
    ? mainProductSection.querySelector('.main-product__row-buttons--sticky')
    : null;

if (
  document.body.classList.contains('page-template-product') &&
  mainButtonsRow instanceof HTMLElement &&
  stickyButtonsRow instanceof HTMLElement
) {
  const mainQuantityInput = mainButtonsRow.querySelector('.quantity__input');
  const stickyQuantityInput = stickyButtonsRow.querySelector('.quantity__input');

  const syncQuantity = function () {
    if (!mainQuantityInput || !stickyQuantityInput) return;
    mainQuantityInput.value = stickyQuantityInput.value;
    mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  if (mainQuantityInput && stickyQuantityInput) {
    stickyQuantityInput.removeAttribute('form');
    stickyQuantityInput.removeAttribute('name');
    stickyQuantityInput.value = mainQuantityInput.value;

    stickyQuantityInput.addEventListener('change', syncQuantity);
  }

  stickyButtonsRow.classList.remove('is-visible');
  document.body.appendChild(stickyButtonsRow);

  const target = mainButtonsRow;

  let headerMarginTop = 0;
  const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
  const headerHeight = parseFloat(headerHeightVar);

  if (!Number.isNaN(headerHeight) && headerHeight > 0) {
    headerMarginTop = -headerHeight;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      stickyButtonsRow.classList.toggle('is-visible', !entry.isIntersecting);
    },
    {
      root: null,
      rootMargin: `${headerMarginTop}px 0px 0px 0px`,
    }
  );

  observer.observe(target);
}
